import React from 'react'

import { Box } from '@material-ui/core'

import MainComponent from './components/MainComponent'

const Home = () => {
  return (
    <Box>
      <MainComponent />
    </Box>
  )
}

export default Home
